import React, { useEffect } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { motion } from 'framer-motion'
import Header from './Header'
import Footer from './Footer'
import { useSEO } from '../hooks/useSEO'

const Layout: React.FC = () => {
  const { i18n } = useTranslation()
  const location = useLocation()

  useEffect(() => {
    // Set language based on URL path
    const isZh = location.pathname.startsWith('/zh')
    const currentLang = isZh ? 'zh' : 'en'
    if (i18n.language !== currentLang) {
      i18n.changeLanguage(currentLang)
    }
  }, [location.pathname, i18n])

  // Update SEO meta tags when language changes
  useSEO()

  return (
    <div className="min-h-screen bg-white flex flex-col">
      <Header />
      <motion.main 
        className="flex-1 container mx-auto px-4 sm:px-6 lg:px-8 py-8 md:py-12"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: [0.25, 0.1, 0.25, 1] }}
      >
        <Outlet />
      </motion.main>
      <Footer />
    </div>
  )
}

export default Layout



